import React from 'react';
import PropTypes from 'prop-types';

import MinusSymbol from '../../../../common/img/components/MinusSymbol';
import PlusSymbol from '../../../../common/img/components/PlusSymbol';
import styles from './QuantityAdjuster.module.scss';

const QuantityAdjuster = (
  {
    incrementPressReleases,
    decrementPressReleases,
    numPressReleases,
  },
) => {
  return (
    <div className={styles.widget}>
      <div className={styles['decrement-button']}>
        <button
          type="button"
          className={styles['button-element']}
          aria-label="Remove press release"
          onClick={() => decrementPressReleases()}
          disabled={numPressReleases === 1 && true}
        >
          <MinusSymbol />
        </button>
      </div>
      <div className={styles['current-number']}>
        {numPressReleases}
      </div>
      <div className={styles['increment-button']}>
        <button
          type="button"
          className={styles['button-element']}
          aria-label="Add press release"
          onClick={() => incrementPressReleases()}
        >
          <PlusSymbol />
        </button>
      </div>
    </div>
  );
};

QuantityAdjuster.propTypes = {
  incrementPressReleases: PropTypes.func.isRequired,
  decrementPressReleases: PropTypes.func.isRequired,
  numPressReleases: PropTypes.number.isRequired,
};

export default QuantityAdjuster;
